import isEmpty from "../helpers/isEmpty";
//------------------
// calc strike rank
//------------------
export default function calcSR(int, dex) {
  if (isEmpty(int) || isEmpty(dex)) {
    return 0;
  } else {
    let sr = Math.floor((int + dex) / 2);
    return sr;
  }
}
